import * as React from 'react';

import { Tooltip, EXTRA_SMALL_ICON_BASE_SRC, } from '../../../Shared';
import { renderPreviouslyAssignedActivitiesTooltipElement } from '../../helpers/unitTemplates';

const checkCircleImg = <img alt="" src={`${EXTRA_SMALL_ICON_BASE_SRC}/check-circle.svg`} />

export const PreviouslyAssignedTooltip = ({ previouslyAssignedActivityData }) => {
  if(!previouslyAssignedActivityData) { return <span /> }
  return(
    <Tooltip
      tooltipText={renderPreviouslyAssignedActivitiesTooltipElement(previouslyAssignedActivityData)}
      tooltipTriggerText={checkCircleImg}
    />
  );
}

export default PreviouslyAssignedTooltip;
